import { Bubble } from '@ant-design/x';
import React, { useState } from 'react';
import { Image, Row, Space, Typography, Tooltip, Button, Card, Avatar } from 'antd';
const { Meta } = Card;
import RiskBubble from './RiskBubble.js';
import { useEffect } from 'react';
import '../index.css';
import { useSelector } from 'react-redux';
import logo from '../../../assets/logo.png';
import {
  UserOutlined,
  LoadingOutlined,
  ExclamationCircleOutlined,
  PaperClipOutlined,
  ReloadOutlined,
} from '@ant-design/icons';
const { Text } = Typography;
import { useTranslation } from 'react-i18next';
import request from '@/utils/request.js';
import { franc } from 'franc-min';
import CustomTranslateIcon from './TranslateIconButton.js';
import AlertIcon from './AlertIcon.js';
import ArrowSwapIcon from './ArrowSwapIcon.js';
import TypingBubble from './TypingBubble.js';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
const commonConfig = {
  styles: { content: { maxWidth: '710px' } },
};

const CustomBubbleRender = props => {
  const {
    message,
    role,
    createdAt,
    typing = {
      step: 5,
      interval: 30,
    },
    onSubmit,
    isReevaluate,
    apiError,
    historyData,
    cotComplete,
    setCotRenderComplete,
  } = props;
  const { t } = useTranslation(['chat', 'translation']);
  const [collapseOpen, setCollapseOpen] = useState(true);
  const [cotBubbleRenderComplete, setBubbleCotRenderComplete] = useState(false);
  const [isComplete, setIsComplete] = useState(false);
  const [disabledSubmit, setDisabledSubmit] = useState(false);
  const { userProfile } = useSelector(state => state.global);
  const { themeMode } = useSelector(state => state.global);
  //翻译
  const [translatedText, setTranslatedText] = useState(null);
  const [isTranslating, setIsTranslating] = useState(false);
  const [showTranslation, setShowTranslation] = useState(false);
  const [hasTranslateError, setHasTranslateError] = useState(false);
  //获取全局语言
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const [shouldShowTranslate, setShouldShowTranslate] = useState(false);
  const encodeBase64 = obj => btoa(unescape(encodeURIComponent(JSON.stringify(obj))));
  const smartLanguageDetection = text => {
    const fullTextLang = franc(text);
    if (fullTextLang === 'eng') {
      const chineseCharCount = (text.match(/[\u4e00-\u9fff]/g) || []).length;
      const totalChars = text.replace(/\s/g, '').length;
      if (chineseCharCount / totalChars > 0.3) {
        return 'yue';
      }
    }
    return fullTextLang;
  };
  const [forceComplete, setForceComplete] = useState(false);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        setForceComplete(true);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  useEffect(() => {
    const rawText = getText();
    const langCode = smartLanguageDetection(rawText || '');
    const francToI18n = code => {
      switch (code) {
        case 'yue':
        case 'cmn':
          return 'zh-TW';
        case 'eng':
          return 'en-US';
        case 'jpn':
          return 'ja-JP';
        default:
          return 'unknown';
      }
    };

    const messageLang = francToI18n(langCode);

    if (messageLang === 'unknown' || messageLang !== currentLang) {
      setShouldShowTranslate(true);
    } else {
      setShouldShowTranslate(false);
    }
  }, [message, i18n.language]);

  const handleTranslate = async () => {
    if (translatedText && showTranslation) {
      setShowTranslation(false);
      return;
    }
    if (translatedText && !showTranslation) {
      setShowTranslation(true);
      return;
    }
    try {
      setIsTranslating(true);
      setHasTranslateError(false);
      const targetLang = currentLang || 'EN';
      const encoded = encodeBase64(getText());
      const result = await request('/conversation/translate', {
        method: 'POST',
        data: {
          text: encoded,
          targetLang,
        },
      });
      setTranslatedText(result);
      setShowTranslation(true);
    } catch (err) {
      console.error('translate fail!', err);
      setHasTranslateError(true);
    } finally {
      setIsTranslating(false);
    }
  };

  const roles = {
    assistant: {
      placement: 'start',
      avatar: {
        src: logo,
      },
      ...commonConfig,
    },
    user: {
      placement: 'end',
      avatar: {
        src: userProfile?.avatar,
        icon: <UserOutlined />,
      },
      ...commonConfig,
    },
  };

  const renderCtaWithWhitelist = ctas => {
    if (!ctas) return [];
    return ctas.map(item => {
      const piiShieldInInsightsEnabled = false;
      const sanitized = typeof item === 'string' ? item : item?.cta || '';
      const isWhite = typeof item === 'object' && item?.isWhite;
      const ctaRelaTag = typeof item === 'object' && item?.ctaRelaTag;
      const isBankCard = piiShieldInInsightsEnabled && isBankCardNumber(sanitized);

      let result = sanitized.trim();
      if (isWhite) {
        result = `${result} DIAMOND`;
      }
      if (isBankCard) {
        result = `${result} SHIELD_ICON`;
      }
      if (ctaRelaTag) {
        result = `${result} CTARELA_TAG`;
      }
      return result;
    });
  };
  const isBankCardNumber = str => {
    if (!str || typeof str !== 'string') return false;

    const bankCardRegex = /\b\d(?:[\d \-/]{11,17})\d\b/;

    if (/[a-zA-Z]/.test(str)) {
      return false;
    }

    if (bankCardRegex.test(str)) {
      str = str.replace(/[^\d]/g, '');
    } else {
      return false;
    }
    return luhnCheck(str);
  };

  const luhnCheck = num => {
    const arr = (num + '')
      .split('')
      .reverse()
      .map(x => parseInt(x));

    const sum = arr.reduce((acc, val, i) => {
      if (i % 2 === 1) {
        val *= 2;
        if (val > 9) val = val - 9;
      }
      return acc + val;
    }, 0);

    return sum % 10 === 0;
  };
  const fields = data => {
    return [
      {
        label: t('riskBubble.fields.involvedOrganization'),
        content: data.involved_organization,
        value: 'involved_organization',
      },
      {
        label: t('riskBubble.fields.inputType'),
        content: data.input_type,
        value: 'input_type',
      },
      {
        label: t('riskBubble.fields.actionableInsights'),
        content: normalizeToString(renderCtaWithWhitelist(data.formatterCtasList)?.join('\n\n')),
        value: 'ctas',
      },
      {
        label: t('riskBubble.fields.possibleIncidentType'),
        content: data.possible_incident_type,
        value: 'possible_incident_type',
      },
      {
        label: t('riskBubble.fields.explanation'),
        content: normalizeToString(data.explanation),
        value: 'explanation',
      },
      {
        label: t('riskBubble.fields.advice'),
        content: normalizeToString(data.advice),
        value: 'advice',
      },
      ...(data.tips
        ? [
            {
              label: t('riskBubble.fields.tips'),
              content: normalizeToString(data.tips),
              value: 'tips',
            },
          ]
        : []),
    ].filter(field => field.content);
  };

  function normalizeToString(input) {
    if (typeof input === 'string') {
      return input.trim();
    }
    if (Array.isArray(input)) {
      return input
        .map(item => String(item).trim())
        .filter(Boolean)
        .join('\n');
    }
    if (typeof input === 'object' && input !== null) {
      return Object.entries(input)
        .map(([key, value]) => {
          const cleanKey = String(key).trim();
          if (typeof value === 'string') {
            return `${cleanKey}: ${value.trim()}`;
          }
          if (Array.isArray(value)) {
            const joined = value
              .map(item => String(item).trim())
              .filter(Boolean)
              .join('\n');
            return `${cleanKey}:\n${joined}`;
          }
          return '';
        })
        .filter(Boolean)
        .join('\n');
    }
    return String(input).trim();
  }

  const renderFieldsToMarkdown = fields => {
    return fields.map(field => `### ${field.label}\n\n${field.content}\n`).join('\n');
  };

  const escapeHTML = str => {
    return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  };

  const getText = () => {
    if (showTranslation && translatedText) return translatedText;
    let messageType = message.type;
    let messageContent = message.content;
    if (message.type == 'result') {
      messageType = message.content.type;
      messageContent = message.content.content;
    }
    switch (messageType) {
      case 'uploading':
        return t('status.uploading');
      case 'error':
        return t('status.uploadFailed');
      case 'text':
        return escapeHTML(messageContent);
      case 'cot':
        return escapeHTML(messageContent);
      case 'reevaluate':
        return messageContent;
      case 'risk':
        return renderFieldsToMarkdown(fields(messageContent));
      case 'image':
        return messageContent?.text || '';
      case 'eml':
        return messageContent?.text || '';
      default:
        return '';
    }
  };

  const renderUploadStatus = (statusType, text) => {
    const statusConfig = {
      uploading: {
        icon: <LoadingOutlined style={{ color: '#1890ff' }} />,
        text: ' ',
      },
      error: {
        icon: <ExclamationCircleOutlined style={{ color: '#ff4d4f' }} />,
        text: 'Upload failed',
      },
    };

    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {statusConfig[statusType].icon}
        <Text type="secondary">{statusConfig[statusType].text}</Text>
        {text && <Text>{text}</Text>}
      </div>
    );
  };

  const onDisabledSubmit = key => {
    setDisabledSubmit(true);
    if (key === 'retry') {
      onSubmit('retry', 0);
    } else {
      onSubmit(key, isReevaluate);
    }
  };

  const renderView = content => {
    const hasHtmlTags = /<\/?[a-z][\s\S]*>/i.test(content);

    if (hasHtmlTags) {
      return (
        <Typography>
          <span dangerouslySetInnerHTML={{ __html: content }} />
        </Typography>
      );
    }
    const contentWithBreaks = content.replace(/\n/g, '<br>');

    return (
      <Typography>
        <span dangerouslySetInnerHTML={{ __html: contentWithBreaks }} />
      </Typography>
    );
  };

  const renderViewReevaluate = content => {
    const contentWithBreaks = content.replace(/\n/g, '<br>');

    return (
      <Row justify="end">
        <Typography>
          <span dangerouslySetInnerHTML={{ __html: contentWithBreaks }} />
        </Typography>
        <Button
          type="primary"
          onClick={() => onDisabledSubmit('reKeyEvaluate')}
          disabled={isReevaluate == 1 || disabledSubmit}
        >
          {t('translation:reevaluate')}
        </Button>
      </Row>
    );
  };

  const renderImageView = (content, imageUrls = []) => {
    return (
      <Typography>
        <Row className="image-view-content">{content}</Row>
        <Image.PreviewGroup>
          <div key="chunk" className="image-chunk">
            {imageUrls.map((url, index) => {
              return (
                <div key={url} className="image-wrapper">
                  <div className="image-index-badge">{index + 1}</div>
                  <Image
                    width={120}
                    height={120}
                    src={url}
                    className="preview-image"
                    preview={{
                      src: url,
                    }}
                  />
                </div>
              );
            })}
          </div>
        </Image.PreviewGroup>
      </Typography>
    );
  };

  const messageRender = msg => {
    let messageType = message.type;
    let messageContent = message.content;
    if (message.type == 'result') {
      messageType = message.content.type;
      messageContent = message.content.content;
    }
    switch (messageType) {
      case 'uploading':
        return renderUploadStatus('uploading', msg);
      case 'error':
        return renderUploadStatus('error', msg);
      case 'text':
        return renderView(msg);
      case 'reevaluate':
        return renderViewReevaluate(msg);
      case 'risk':
        return (
          <RiskBubble
            content={msg}
            score={messageContent?.risk_score}
            ctas={messageContent?.formatterCtasList}
            isReevaluate={isReevaluate}
            isComplete={isComplete}
            level={messageContent?.risk_level}
          />
        );
      case 'image':
        return (
          <>
            {messageContent?.imageUrls?.length > 0
              ? renderImageView(msg, messageContent.imageUrls)
              : renderUploadStatus('uploading', msg)}
          </>
        );
      case 'eml':
        return (
          <>
            {renderView(msg)}
            <Card icon={<PaperClipOutlined />}>
              <Meta
                avatar={<Avatar icon={<PaperClipOutlined />} />}
                title={
                  message.fileName.length > 20
                    ? message.fileName.substring(0, 20) + '...'
                    : message.fileName
                }
                description={t('chat:emlName')}
              />
            </Card>
          </>
        );
      default:
        return null;
    }
  };
  const onCotComplete = () => {
    if (cotComplete) {
      setCotRenderComplete(true);
      setBubbleCotRenderComplete(true);
    }
  };
  const onTypingComplete = () => {
    setIsComplete(true);
  };

  const renderDate = () => {
    const date = createdAt ? new Date(createdAt) : new Date();
    return <Typography className="date">{date.toLocaleString()}</Typography>;
  };
  let solidColor = themeMode === 'light' ? '1.5px solid #AAAAAA' : '2px solid #7F7F7F';
  return (
    <>
      {message.type === 'cot' && (
        <Bubble
          variant="text"
          content={
            /* JSX 结构 */
            <div style={{ margin: 0, padding: 0 }}>
              <Button
                data-testid="scams-report-thought-chain-toggle"
                type="default"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '4px 12px',
                  margin: 0,
                  background: 'transparent',
                  boxShadow: 'none',
                  height: 'auto',
                  width: 'auto',
                  minWidth: 'fit-content',
                }}
                onClick={() => setCollapseOpen(!collapseOpen)}
              >
                {cotBubbleRenderComplete
                  ? t('chat:deepEnd')
                  : historyData
                    ? t('chat:deepEnd')
                    : t('chat:deepStart')}{' '}
                {collapseOpen ? <DownOutlined /> : <UpOutlined />}
              </Button>

              <div
                style={{
                  margin: 0,
                  padding: 0,
                  marginTop: 18,
                  display: collapseOpen ? 'block' : 'none',
                  borderLeft: solidColor,
                  paddingLeft: '10px',
                  marginLeft: '15px',
                }}
              >
                <TypingBubble
                  fullText={getText()}
                  onTypingComplete={onCotComplete}
                  historyData={historyData}
                />
              </div>
            </div>
          }
          {...roles[role]}
        />
      )}

      {message.type == 'result' && (
        <Bubble
          header={renderDate()}
          typing={
            isComplete ||
            ['uploading', 'error'].includes(message.content.type) ||
            historyData ||
            forceComplete
              ? false
              : {
                  step: 5,
                  interval: 30,
                }
          }
          content={showTranslation && translatedText ? translatedText : getText()}
          messageRender={messageRender}
          onTypingComplete={onTypingComplete}
          footer={
            role === 'assistant' &&
            !['uploading', 'error'].includes(message.content.type) && (
              <Space size={0}>
                <span className="chat-action-button">
                  <Text copyable={{ text: getText() }} />
                </span>
                {shouldShowTranslate && (
                  <Tooltip
                    title={
                      hasTranslateError
                        ? t('tooltip.translateError')
                        : showTranslation
                          ? t('tooltip.showOriginal')
                          : t('tooltip.translate')
                    }
                  >
                    <span
                      className="chat-action-button-t"
                      style={{
                        display: 'inline-flex',
                        cursor: isTranslating ? 'not-allowed' : 'pointer',
                        opacity: isTranslating ? 0.5 : 1,
                        verticalAlign: 'middle',
                      }}
                      onClick={isTranslating || hasTranslateError ? null : handleTranslate}
                    >
                      {isTranslating ? (
                        <LoadingOutlined className="translate-icon" style={{ color: '#1890ff' }} />
                      ) : hasTranslateError ? (
                        <AlertIcon />
                      ) : translatedText && showTranslation ? (
                        <ArrowSwapIcon />
                      ) : (
                        <CustomTranslateIcon className="translate-icon" />
                      )}
                    </span>
                  </Tooltip>
                )}
                {apiError && (
                  <Tooltip title={t('tooltip.retry')}>
                    <span className="chat-action-button-t">
                      <ReloadOutlined
                        className="translate-icon"
                        onClick={() => onDisabledSubmit('retry')}
                      />
                    </span>
                  </Tooltip>
                )}
              </Space>
            )
          }
          {...roles[role]}
          avatar={{
            src: undefined,
            style: {
              background: 'transparent',
              width: 32,
              height: 32,
            },
          }}
          styles={{ content: { width: '710px' } }}
        />
      )}

      {message.type != 'cot' && message.type != 'result' && (
        <Bubble
          header={renderDate()}
          typing={isComplete || ['uploading', 'error'].includes(message.type) ? false : typing}
          content={showTranslation && translatedText ? translatedText : getText()}
          messageRender={messageRender}
          onTypingComplete={onTypingComplete}
          footer={
            role === 'assistant' &&
            !['uploading', 'error'].includes(message.type) && (
              <Space size={0}>
                <span className="chat-action-button">
                  <Text copyable={{ text: getText() }} />
                </span>
                {shouldShowTranslate && (
                  <Tooltip
                    title={
                      hasTranslateError
                        ? t('tooltip.translateError')
                        : showTranslation
                          ? t('tooltip.showOriginal')
                          : t('tooltip.translate')
                    }
                  >
                    <span
                      className="chat-action-button-t"
                      style={{
                        display: 'inline-flex',
                        cursor: isTranslating ? 'not-allowed' : 'pointer',
                        opacity: isTranslating ? 0.5 : 1,
                        verticalAlign: 'middle',
                      }}
                      onClick={isTranslating || hasTranslateError ? null : handleTranslate}
                    >
                      {isTranslating ? (
                        <LoadingOutlined className="translate-icon" style={{ color: '#1890ff' }} />
                      ) : hasTranslateError ? (
                        <AlertIcon />
                      ) : translatedText && showTranslation ? (
                        <ArrowSwapIcon />
                      ) : (
                        <CustomTranslateIcon className="translate-icon" />
                      )}
                    </span>
                  </Tooltip>
                )}
                {apiError && (
                  <Tooltip title={t('tooltip.retry')}>
                    <span className="chat-action-button-t">
                      <ReloadOutlined
                        className="translate-icon"
                        onClick={() => onDisabledSubmit('retry')}
                      />
                    </span>
                  </Tooltip>
                )}
              </Space>
            )
          }
          {...roles[role]}
        />
      )}
    </>
  );
};

export default CustomBubbleRender;
